import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-4 grain">
      <div className="relative z-10 max-w-md w-full glass rounded-3xl p-10 text-center">
        <XCircle className="w-16 h-16 text-mustard mx-auto" />
        <h1 className="font-display font-bold text-2xl mt-6">Inscription en pause</h1>
        <p className="text-cream/60 mt-3 text-sm">Ton paiement a été annulé. Ton inscription n'a pas été finalisée — tu peux reprendre quand tu veux.</p>
        <button data-testid="cancel-home-btn" onClick={() => navigate("/")} className="btn-mustard rounded-full px-6 py-3 mt-7">Retour au site</button>
      </div>
    </div>
  );
}
